import * as yup from "yup";
import { Roles } from "../rbac/rbac";
import {
  User,
  validateGroupsRolesSelected,
  validateGroupsRolesLength,
} from "./user";
import { MAX_EMAIL_LENGTH } from "../../../utils/email-utils";

export type CreateUser = Omit<User, "id" | "orgId" | "disabled" | "roles"> & {
  password: string;
  roles: Array<Roles>;
};

export const PasswordRegex =
  /^[a-zA-Z0-9!"#\$%&'\(\)=~\|\-\^\\@\[;:\],\.\/`\{\+\*\}>\?_]{8,50}$/;

const baseValidations = {
  name: yup
    .string()
    .required("名前を入力してください。")
    .max(64, "名前は64文字以下で入力してください。"),
  groupsRoles: yup
    .object()
    .test(
      "validate-groups-roles-selected",
      "グループを選択してください。",
      (val) => !validateGroupsRolesSelected(val),
    )
    .test(
      "validate-groups-roles-length",
      "グループは20個まで選択できます。",
      (val) => !validateGroupsRolesLength(val),
    ),
} as const;

// TODO(adshidtadka): Formikをやめてユーザー作成時と更新時でバリデーション内容を統一する
export const CreateUserYup = yup.object().shape({
  ...baseValidations,
  accountName: yup
    .string()
    .required("アカウント名を入力してください。")
    .max(256, "アカウント名は256文字以下で入力してください。")
    .matches(
      /^[a-zA-Z0-9!#$%&'+/=?^_`{|}~@.-]*$/,
      "アカウント名は半角英数字と記号のみ使用可能です。",
    ),
  roles: yup
    .array()
    .required("ロールを選択してください。")
    .min(1, "ロールを選択してください。")
    .test(
      "validate-multiple-roles-for-admin",
      "特権管理者ロールと他のロールを同時に指定することはできません。",
      (roles: Roles[]) => !roles.includes("Admin") || roles.length === 1,
    ),
  password: yup.string().when("authMethod", {
    is: "password",
    then: (schema) =>
      schema
        .required("パスワードを入力してください。")
        .matches(
          PasswordRegex,
          "パスワードは半角英数字記号8文字以上50文字以内で入力してください",
        ),
  }),
  externalUserId: yup.string().when("authMethod", {
    is: "saml",
    then: (schema) =>
      schema
        .required("外部ユーザーIDを入力してください。")
        .max(256, "外部ユーザーIDは256文字以下で入力してください。")
        .matches(
          /^[a-zA-Z0-9!#$%&'+/=?^_`{|}~@.-]*$/,
          "外部ユーザーIDは半角英数字と記号のみ使用可能です。",
        ),
  }),
  emails: yup
    .array()
    .of(
      yup
        .string()
        .max(
          MAX_EMAIL_LENGTH,
          `メールアドレスは${MAX_EMAIL_LENGTH}文字以内で入力してください`,
        )
        .email("メールアドレスの形式が正しくありません"),
    ),
});
